import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Query, Question } from "@types";

export const useGetQuestions = (examQuery: Query, enable: boolean = true) => {

    const axios = useAxios();
    const {t} = useTranslation();

    const fetchQuestions = async (): Promise<{items: Question[]}> => {
        try {
            const { data } = await axios.get(`/api/questions`, {params: examQuery});
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getQuestions"));
        }
    }

    return useQuery({queryKey: ["questions",examQuery], queryFn: fetchQuestions, staleTime: Infinity, enabled: enable})
}